import { AppType, BuilderEnvironment, Theme } from '../builder.interface';
import { BaseBuilderEnvs } from './environment.constants';

export const builderEnvironment: BuilderEnvironment = {
  ...BaseBuilderEnvs[AppType.Gdesemena],
  recaptcha: '6LfRSyIUAAAAAHZyC_5pyjkyUMDxyWTRw32s8nlk',
  theme: Theme.DEFAULT,
};
